/**
 * Sticky Add to Cart Button for Mobile
 * Adds margin adjustment for Gladly Chat + SpiceGems Switcher widgets
 */
document.addEventListener('DOMContentLoaded', function() {
  const originalButton = document.querySelector('.product-form__submit');
  const productForm = document.querySelector('.product-form__form');
  const footer = document.querySelector('footer.footer, .footer, footer, #footer') ||
                 document.querySelector('[class*="footer"]');
  
  let stickyContainer = null;
  let stickyButton = null;
  let lastButtonState = null;
  let hasAnimated = false;
  let intervalHandle = null;

  if (!originalButton || !productForm) return;

  // -------------------------------
  // Create Sticky Container
  // -------------------------------
  function createStickyContainer() {
    if (stickyContainer) return;
    stickyContainer = document.createElement('div');
    stickyContainer.className = 'sticky-add-to-cart-container';
    stickyContainer.style.display = 'none';

    stickyButton = originalButton.cloneNode(true);
    stickyButton.classList.add('sticky-mode');
    stickyButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      originalButton.click();
    });

    stickyContainer.appendChild(stickyButton);
    document.body.appendChild(stickyContainer);
  }

  // -------------------------------
  // Sync Button States
  // -------------------------------
  function syncButtonStates() {
    if (!stickyButton) return;
    stickyButton.toggleAttribute('disabled', originalButton.hasAttribute('disabled'));
    stickyButton.setAttribute('aria-disabled', originalButton.getAttribute('aria-disabled') || 'false');
    stickyButton.classList.toggle('loading', originalButton.classList.contains('loading'));
    stickyButton.textContent = originalButton.textContent;
  }

  // -------------------------------
  // Footer Visibility
  // -------------------------------
  function isFooterVisible() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.scrollHeight;
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      const footerTop = footerRect.top + scrollY;
      return scrollY + windowHeight >= footerTop - 50;
    }
    return scrollY + windowHeight >= documentHeight - 100;
  }

  // -------------------------------
  // Quantity Visibility
  // -------------------------------
  function isQuantityVisible() {
    const quantitySection = document.querySelector('.product-form__quantity');
    if (!quantitySection) return false;
    const rect = quantitySection.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  // -------------------------------
  // Adjust Widgets (Gladly + Switcher)
  // -------------------------------
  function updateWidgetsMargin(addMargin) {
    if (intervalHandle) {
      clearInterval(intervalHandle);
      intervalHandle = null;
    }

    const updateAll = () => {
      const gladlyChat = document.getElementById('gladlyChat_container');
      const spicegemsSwitcher = document.querySelector('.spicegems_switcher-fixed-position');

      if (gladlyChat) applyWidgetMargin(gladlyChat, addMargin);
      if (spicegemsSwitcher) applyWidgetMargin(spicegemsSwitcher, addMargin);
    };

    // Apply immediately
    updateAll();

    // If widgets not found yet, poll for up to 10s
    if (addMargin) {
      const startTime = Date.now();
      intervalHandle = setInterval(() => {
        const elapsed = Date.now() - startTime;
        if (elapsed >= 10000) {
          clearInterval(intervalHandle);
          intervalHandle = null;
          return;
        }
        updateAll();
      }, 100);
    }
  }

  // -------------------------------
  // Apply margin to widget
  // -------------------------------
  function applyWidgetMargin(element, addMargin) {
    if (addMargin) {
      element.classList.add('spicegems_switcher-fixed-position');
      element.style.marginBottom = '7rem';
      element.style.setProperty('margin-bottom', '7rem', 'important');
    } else {
      element.style.removeProperty('margin-bottom');
    }
  }

  // -------------------------------
  // Toggle Sticky Button
  // -------------------------------
  function toggleStickyButton() {
    const isMobile = window.innerWidth < 768;
    if (!isMobile) {
      if (stickyContainer) stickyContainer.style.display = 'none';
      originalButton.style.visibility = '';
      updateWidgetsMargin(false);
      lastButtonState = null;
      return;
    }

    const quantityVisible = isQuantityVisible();
    const footerVisible = isFooterVisible();
    let currentState = quantityVisible ? 'normal' : footerVisible ? 'hidden' : 'sticky';

    if (currentState !== lastButtonState) {
      createStickyContainer();
      switch (currentState) {
        case 'normal':
          originalButton.style.visibility = '';
          stickyContainer.style.display = 'none';
          hasAnimated = false;
          updateWidgetsMargin(false);
          break;
        case 'hidden':
          originalButton.style.visibility = 'hidden';
          stickyContainer.style.display = 'none';
          updateWidgetsMargin(false);
          break;
        case 'sticky':
          originalButton.style.visibility = 'hidden';
          if (!hasAnimated) {
            stickyContainer.style.animation = 'none';
            stickyContainer.style.display = 'block';
            void stickyContainer.offsetWidth;
            stickyContainer.style.animation = '';
            hasAnimated = true;
          } else {
            stickyContainer.style.display = 'block';
          }
          syncButtonStates();
          updateWidgetsMargin(true);
          break;
      }
      lastButtonState = currentState;
    } else if (currentState === 'sticky') {
      syncButtonStates();
    }
  }

  // -------------------------------
  // Observe Button Changes
  // -------------------------------
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (['attributes', 'characterData', 'childList'].includes(m.type)) syncButtonStates();
    });
  });

  observer.observe(originalButton, {
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled', 'class'],
    childList: true,
    characterData: true,
    subtree: true
  });

  // -------------------------------
  // Scroll + Resize Listeners
  // -------------------------------
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        toggleStickyButton();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', toggleStickyButton);
  toggleStickyButton();
});
